import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const ShopCard = ({
  Title = "Title",
  bgColor = "bg-white",
  imgSource = "",
  btnTitle = "Button",
  cardText = "",
  category,
}) => {
  return (
    <div className={`p-3 lg:px-5 ${bgColor}`}>
      <div className="container mx-auto">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-5">
          <div className="w-1/2 aspect-square lg:w-1/4 shrink-0 rounded-lg overflow-hidden">
            <motion.img
              src={imgSource}
              alt="Product Img"
              className="size-full overflow-cover"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
            />
          </div>
          <div className="flex flex-col items-center pt-3 lg:pt-0">
            <h1 className="font-bold display-6">{Title}</h1>
            <p className="mt-2">{cardText}</p>
            <Link
              to={`/collections/${category}`}
              className="flex justify-center lg:justify-start mt-2"
            >
              <button className="btn theme-outline-btn">{btnTitle}</button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShopCard;
